<template>
    <section class="edit-meeting">
        <form class="edit-meeting__form">
            <button class="edit-meeting__close"
                    @click="
                    (e)=>
                {
                e.preventDefault();
                this.$emit('setVisible');
                this.$store.commit('hideEditMeeting');
                }
                "
                >
                <img src="../../../../../assets/icons/components/exit.svg" />
            </button>
            <section class="edit-meeting__form-wrapper">
                <h2 class="edit-meeting__section-title">{{$t('com.global.edit')}} {{$t('com.global.session')}}</h2>
                <section class="edit-meeting__top">
                    <h3 class="
                            edit-meeting__section-title
                            edit-meeting__section-title--small
                        ">
                        {{$t('com.edit-meeting.section-term')}}
                    </h3>
                    <section class="edit-meeting__row-double">
                        <section class="edit-meeting__col-double">
                            <label class="edit-meeting__label">{{$t('com.edit-meeting.session-term')}}</label>
                            <section class="edit-meeting__picker-wrapper">
                                <input type="date"
                                       class="edit-meeting__picker"
                                       v-model="meeting_date"
                                       v-error="{
                                        errors,
                                        input_key: 'meeting_date',
                                    }" />
                                <ErrorMessage v-if="isError('meeting_date', this.errors)"
                                              :errorMsgs="
                                        passErrorMsg(
                                            'meeting_date',
                                            this.errors
                                        )
                                    " />
                            </section>
                        </section>
                        <section class="edit-meeting__col-double">
                            <label class="edit-meeting__label">{{$t('com.file.public-session.hour')}}</label>
                            <section class="edit-meeting__picker-wrapper">
                                <input type="time"
                                       class="edit-meeting__picker"
                                       v-model="meeting_time"
                                       v-error="{
                                        errors,
                                        input_key: 'meeting_time',
                                    }" />
                                <ErrorMessage v-if="isError('meeting_time', this.errors)"
                                              :errorMsgs="
                                        passErrorMsg(
                                            'meeting_time',
                                            this.errors
                                        )
                                    " />
                            </section>
                        </section>
                    </section>

                    <section class="edit-meeting__row-double">
                        <section class="edit-meeting__col-double">
                            <label class="edit-meeting__label">{{$t('com.edit-meeting.end-meeting-date')}}</label>
                            <section class="edit-meeting__picker-wrapper">
                                <input type="date"
                                       class="edit-meeting__picker"
                                       v-model="end_meeting_date"
                                       :disabled="hasAdditionalMeetingDates"
                                       v-tooltip="hasAdditionalMeetingDates ? $t('com.edit-meeting.end-meeting-date-disabled-hint') : ''"
                                       v-error="{
                                        errors,
                                        input_key: 'end_meeting_date',
                                    }" />
                                <ErrorMessage v-if="isError('end_meeting_date', this.errors)"
                                              :errorMsgs="
                                        passErrorMsg(
                                            'end_meeting_date',
                                            this.errors
                                        )
                                    " />
                            </section>
                        </section>
                    </section>

                    <section class="edit-meeting__row">
                        <label v-if="hasAdditionalMeetingDates" class="edit-meeting__label">{{$t('com.edit-meeting.additional-meeting-dates')}}</label>
                        <section class="edit-meeting__terms-row"
                                 v-for="(term, index) in additional_meeting_dates"
                                 :key="`additional-meeting-date-${index}`">
                            <section class="edit-meeting__picker-wrapper">
                                <input type="date"
                                       class="edit-meeting__picker"
                                       v-model="term.date"
                                       v-error="{
                                        errors,
                                        input_key: additionalTermErrorKey(index, 'date'),
                                    }" />
                                <ErrorMessage v-if="isError(additionalTermErrorKey(index, 'date'), this.errors)"
                                              :errorMsgs="passErrorMsg(additionalTermErrorKey(index, 'date'), this.errors)" />
                            </section>
                            <section class="edit-meeting__picker-wrapper">
                                <input type="time"
                                       class="edit-meeting__picker"
                                       v-model="term.time"
                                       v-error="{
                                        errors,
                                        input_key: additionalTermErrorKey(index, 'time'),
                                    }" />
                                <ErrorMessage v-if="isError(additionalTermErrorKey(index, 'time'), this.errors)"
                                              :errorMsgs="passErrorMsg(additionalTermErrorKey(index, 'time'), this.errors)" />
                            </section>
                            <button type="button"
                                    class="edit-meeting__terms-action"
                                    v-tooltip="$t('com.edit-meeting.remove-additional-meeting-date')"
                                    @click.prevent="removeAdditionalMeetingDate(index)">
                                <img src="@/assets/icons/components/bin.svg" />
                            </button>
                        </section>
                        <button type="button"
                                class="edit-meeting__terms-add"
                                :disabled="isEndMeetingDateSet"
                                v-tooltip="isEndMeetingDateSet ? $t('com.edit-meeting.additional-meeting-dates-hint') : ''"
                                @click.prevent="addAdditionalMeetingDate">
                            + {{$t('com.edit-meeting.add-additional-meeting-date')}}
                        </button>
                    </section>

                    <section class="edit-meeting__group">
                        <h3 class="
                                edit-meeting__section-title
                                edit-meeting__section-title--small
                            ">
                            {{$t('com.edit-meeting.section-details')}}
                        </h3>
                    </section>

                    <section class="edit-meeting__row-double">
                        <section class="edit-meeting__col-double">
                            <label class="edit-meeting__label">{{$t('com.edit-meeting.session-number')}}</label>
                            <input type="number"
                                   @keypress="onlyNumber"
                                   class="edit-meeting__input-text edit-meeting__input-text--small"
                                   :placeholder="$t('com.edit-meeting.session-number-placeholder')"
                                   v-model="number"
                                   v-error="{ errors, input_key: 'number' }" />
                            <ErrorMessage v-if="isError('number', this.errors)"
                                          :errorMsgs="passErrorMsg('number', this.errors)" />
                        </section>
                        <section class="edit-meeting__col-double">
                            <label class="edit-meeting__label">{{$t('com.edit-meeting.signature')}}</label>
                            <input type="text"
                                   maxlength="100"
                                   class="edit-meeting__input-text edit-meeting__input-text--small"
                                   :placeholder="$t('com.edit-meeting.signature-placeholder')"
                                   v-model="signature"
                                   v-error="{ errors, input_key: 'signature' }" />
                            <CharactersCounter :text="signature" :maxLenght="100" />
                            <ErrorMessage v-if="isError('signature', this.errors)" :errorMsgs="passErrorMsg('signature', this.errors)" />
                        </section>
                    </section>

                    <section class="edit-meeting__row">
                        <label class="edit-meeting__label">{{$t('com.edit-meeting.session-name')}}</label>
                        <input type="text"
                               maxlength="400"
                               class="edit-meeting__input-text"
                               :placeholder="$t('com.edit-meeting.session-name-placeholder')"
                               v-model="name"
                               v-error="{ errors, input_key: 'name' }" />
                        <CharactersCounter :text="name" :maxLenght="400" />
                        <ErrorMessage v-if="isError('name', this.errors)" :errorMsgs="passErrorMsg('name', this.errors)" />
                    </section>
                    <section class="edit-meeting__row">
                        <label class="edit-meeting__label">{{$t('com.edit-meeting.session-place')}}</label>
                        <textarea rows="4"
                                  maxlength="800"
                                  class="edit-meeting__input-text"
                                  :placeholder="$t('com.edit-meeting.session-place-placeholder')"
                                  v-model="meeting_place"
                                  v-error="{ errors, input_key: 'meeting_place' }" />
                        <CharactersCounter :text="meeting_place" :maxLenght="800" />
                        <ErrorMessage v-if="isError('meeting_place', this.errors)" :errorMsgs="passErrorMsg('meeting_place', this.errors)" />
                    </section>
                    <section class="edit-meeting__row" v-if="roomMapModule === 1 && roomMaps != null && roomMaps.length > 0">
                        <label class="edit-meeting__label">
                            {{$t('com.file.room-map-settings.rooms-plans')}}
                        </label>
                        <div class="edit-meeting__select-wrapper">
                            <select v-model="selectedRoomMapId"
                                    class="edit-meeting__select" :disabled="isInteractive() === true">
                                <option v-for="room in roomMaps"
                                        :key="room.id"
                                        :value="room.id">
                                    {{ room.name }}
                                </option>
                            </select>
                        </div>
                    </section>
                </section>
                <section class="edit-meeting__groups">
                    <h3 class="
                            edit-meeting__section-title
                            edit-meeting__section-title--small
                        ">
                        {{$t('com.edit-meeting.session-groups')}}
                    </h3>
                    <ErrorMessage v-if="isError('group_ids', this.errors)"
                                  :errorMsgs="passErrorMsg('group_ids', this.errors)" />
                    <section class="edit-meeting__checkbox-list">
                    <section class="edit-meeting__checkbox-section"
                             v-for="group in filterGroups()"
                             :key="group.id">
                        <CheckBoxButton :value="group.id"
                                        :id="group.id"
                                        :checked="checkedGroupsIds.indexOf(group.id) !== -1"
                                        @setGroupId="
                                        (value)=>
                            (this.checkedGroupsIds = value)
                            "
                            :idsArray="checkedGroupsIds"
                            />
                            <label class="
                                edit-meeting__label
                                edit-meeting__label--checkbox
                            "
                                   :for="group.id">{{ group.name }}</label>
                    </section>
                    </section>
                </section>
                <SharedUsersPicker v-if="hasMembersOnlyGroup"
                                   class="edit-meeting__sharing"
                                   v-model="sharedUsers"
                                   :disabled="!sharedUsersLoaded || $store.state.userStore.isLoading"
                                   @busy="sharedUsersBusy = $event"
                                   :groupIds="checkedGroupsIds"
                                   :title="$t('com.edit-meeting.sharing-title')"
                                   :descriptions="[$t('com.edit-meeting.sharing-description')]" />
                <section class="edit-meeting__identity">
                    <h3 class="
                            edit-meeting__section-title
                            edit-meeting__section-title--small
                        ">
                        {{$t('com.file.contact-box.settings')}}
                    </h3>
                   
                    <section>
                        <div class="form-bootstrap-check form-bootstrap-switch">
                            <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="public-meeting" v-model="isPublic" @click="setIsAuthorized()" />
                            <label class="form-bootstrap-check-label" for="public-meeting">{{$t('com.file.meeting.session-public')}}</label>
                            <section name="externalTrigger2"
                                     class="edit-meeting__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-meeting__tooltip" />
                                <Hint :title="$t('com.file.meeting.session-public')"
                                      :text="$t('com.edit-meeting.session-public-hint')" />
                            </section>
                        </div>
                    </section>

                    <section>
                        <div class="form-bootstrap-check form-bootstrap-switch">
                            <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="authorized-meeting" v-model="is_authorized"  @click="setIsPublic()"/>
                            <label class="form-bootstrap-check-label" for="authorized-meeting">{{$t('com.edit-meeting.session-show-for-users')}}</label>
                            <section name="externalTrigger2"
                                     class="edit-meeting__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-meeting__tooltip" />
                                <Hint style="left: calc(100% - 310px)" :title="$t('com.edit-meeting.session-show-for-users')"
                                      :text="$t('com.edit-meeting.session-show-for-users-hint')" />
                            </section>
                        </div>
                    </section>


                </section>
                <section class="edit-meeting__bottom">
                    <button class="edit-meeting__bottom-btn"
                            @click="
                            (e)=>
                        {
                        e.preventDefault();
                        this.$emit('setVisible');
                        this.$store.commit('hideEditMeeting');
                        }
                        "
                        >
                        {{$t('com.global.cancel')}}
                    </button>
                    <button @click="(e) => editSession(e)"
                            :disabled="sharedUsersLoading || sharedUsersBusy || $store.state.userStore.isLoading"
                            class="
                            edit-meeting__bottom-btn
                            edit-meeting__bottom-btn--red
                        ">
                        {{$t('com.global.save')}}
                    </button>
                </section>
            </section>
        </form>
    </section>
</template>

<script>
    import MeetingService from "../../../../../services/meetings.service";
    import SessionService from "../../../../../services/session.service";
    import moment from "moment";
    import {
        passErrorMsg,
        isError,
        setErrors,
    } from "../../../../../formValidation/main";
    import {
        additionalTermErrorKey,
        createEmptyAdditionalTerm,
        toAdditionalTermPayload,
        toAdditionalTermRows,
        validateAdditionalTerms,
    } from "@/helpers/session.dates.helper";

    import CheckBoxButton from "../../../../BasicControls/CheckBoxButton.vue";
    import Hint from "../../../../BasicControls/Hint.vue";
    import ErrorMessage from "../../../../BasicControls/ErrorMessage.vue";
    import CharactersCounter from "../../../../../components/BasicControls/CharactersCounter.vue"
    import { sessionFormRulesConfig } from "../../../../../config/session-form-rules.config.js";
    import { encryptStorage } from '@/services/encrypt.service';
    import RoomMapService from "@/services/room.map.service.js";
    import SharedUsersPicker from "../../../../Modals/Session/SharedUsersPicker.vue";

    export default {
        name: "EditMeeting",
        data() {
            return {
                groups: [],
                checkedGroupsIds: [],
                checkedSessionGroupsStartPosition: [],
                name: "",
                isPublic: false,
                is_authorized: false,
                is_published: false,
                meeting_date: "",
                meeting_time: "",
                meeting_place: "",
                end_meeting_date: null,
                additional_meeting_dates: [],
                number: "",
                signature: "",
                errors: [],
                votings: [],
                roomMapModule: encryptStorage.getItem('modules').ps,
                selectedRoomMapId: null,
                sharedUsers: [],
                sharedUsersLoaded: false,
                sharedUsersLoading: true,
                sharedUsersBusy: false
            };
        },
        props: {
            sessionId: Number
        },
        computed: {
            // Zakres wielodniowy i lista dodatkowych terminow wykluczaja sie wzajemnie
            hasAdditionalMeetingDates() {
                return this.additional_meeting_dates.length > 0;
            },
            isEndMeetingDateSet() {
                return this.end_meeting_date !== null && this.end_meeting_date !== "";
            },
            roomMaps() {
                return this.$store.state.roomMap.roomMaps;
            },
            // udostępnianie ma sens tylko, gdy choć jedna grupa posiedzenia jest "tylko dla członków"
            hasMembersOnlyGroup() {
                return this.groups.some((group) => group.only_for_members && this.checkedGroupsIds.indexOf(group.id) !== -1);
            }
        },
        components: {
            CheckBoxButton,
            Hint,
            ErrorMessage,
            CharactersCounter,
            SharedUsersPicker
        },
        async mounted() {
            this.$store.state.userStore.isLoading = true;
            MeetingService.groups(false).then((response) => { 
                this.groups = response.data;
                this.$store.state.userStore.isLoading = false;
            });
            const {
                name,
                number,
                signature,
                meeting_place,
                meeting_date,
                end_meeting_date,
                additional_meeting_dates,
                is_published,
                is_public,
                is_authorized,
                groups,
            } = await this.fetchSessionToEdit();
            this.checkedGroupsIds = groups.map((group) => group.id);
            this.checkedSessionGroupsStartPosition = groups.map((group) => group.id);
            this.name = name;
            this.number = number;
            this.signature = signature;
            this.meeting_place = meeting_place;
            this.meeting_date = this.getDate(meeting_date);
            this.meeting_time = this.getTime(meeting_date);
            this.end_meeting_date = this.getDate(end_meeting_date);
            this.additional_meeting_dates = toAdditionalTermRows(additional_meeting_dates);
            this.is_published = is_published;
            this.isPublic = is_public;
            this.is_authorized = is_authorized;

            await this.loadSharedUsers();
            await this.getAllRoomMaps();
            await this.getRoomMapForSession();
        },
        watch: {
            hasAdditionalMeetingDates(hasDates) {
                if (hasDates)
                    this.end_meeting_date = null;
            },
        },
        methods: {
            additionalTermErrorKey(index, field) {
                return additionalTermErrorKey(index, field);
            },
            async loadSharedUsers() {
                this.sharedUsersLoading = true;
                try {
                    const response = await MeetingService.getSessionShares(this.sessionId);
                    this.sharedUsers = response.data;
                    this.sharedUsersLoaded = true;
                } catch (e) {
                    console.log(e);
                } finally {
                    this.sharedUsersLoading = false;
                }
            },
            addAdditionalMeetingDate() {
                if (this.isEndMeetingDateSet)
                    return;

                this.additional_meeting_dates.push(createEmptyAdditionalTerm());
            },
            removeAdditionalMeetingDate(index) {
                this.additional_meeting_dates.splice(index, 1);
            },
            isInteractive() {
                return this.$store.state.appStore.isInInteractiveMode;
            },
            async getAllRoomMaps() {
                if (this.roomMapModule === 1) {
                    try {
                        await RoomMapService.GetAll();
                    } catch (e) {
                        console.log(e)
                    }
                }
            },
            async getRoomMapForSession() {
                if (this.roomMapModule === 1) {
                    try {
                        let result = await RoomMapService.getRoomMapForSession(this.sessionId)

                        if (result.status == 200) {
                            this.selectedRoomMapId = result.data.id;
                        }

                    } catch (e) {
                        if (e.response.status == 401)
                            this.$router.push({ name: 'Login' })
                    }
                }
            },
            async saveRoomMapForSession(sessionId) {
                if (this.roomMapModule === 1) {
                    try {
                        if (this.selectedRoomMapId == null) return;

                        await RoomMapService.setRoomMapForSession(this.selectedRoomMapId, sessionId);
                    } catch (error) {
                        console.error(error);
                    }
                }
            },
            onlyNumber($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57)) {
                    $event.preventDefault();
                }
            },
            setIsAuthorized() {
                if (this.is_authorized == false) {
                    this.is_authorized = true;
                }
            },
            setIsPublic() {
                if (this.is_authorized == true) {
                    this.isPublic = false;
                }
            },

            async fetchSessionToEdit() {
                try {
                    let response = await SessionService.getSessionForEdit(this.sessionId);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    this.votings = response.data.votings;

                    return response.data.session;
                }
                catch (e) {
                    console.log(e);
                }
            },
            editSession(e) {
                e.preventDefault();
                if (this.sharedUsersLoading || this.sharedUsersBusy || this.$store.state.userStore.isLoading) {
                    return;
                }
                const data = {
                    name: this.name,
                    number: this.number,
                    signature: this.signature,
                    meeting_place: this.meeting_place,
                    meeting_date: this.meeting_date,
                    meeting_time: this.meeting_time,
                    end_meeting_date: this.end_meeting_date,
                    is_published: this.is_published,
                    is_public: this.isPublic,
                    is_authorized: this.is_authorized,
                    group_ids: this.checkedGroupsIds,
                    additional_meeting_dates: toAdditionalTermPayload(this.additional_meeting_dates),
                    // null = bez zmian, gdy listy udostępnień nie udało się wczytać
                    shared_user_ids: this.sharedUsersLoaded ? this.sharedUsers.map((user) => user.id) : null,
                };

                if (data.number == "")
                    data.number = null;

                if (this.validate(data) == false)
                    return;

                if (this.votings != null && this.votings.length > 0 && this.checkedSessionGroupsStartPosition.sort().join(',') !== this.checkedGroupsIds.sort().join(',')) {
                    // check validation in groups
                    const actionToFire = () => {
                        if (this.$store.state.appStore.selectedButtonActionId == 1) {
                            // update only session data
                            this.updateSessionData(data);
                        }
                        else if (this.$store.state.appStore.selectedButtonActionId == 2) {
                            // update sesion and all votings groups
                            this.updateSessionDataWithVotingsGroups(data);
                        }
                        else {
                            this.$store.state.userStore.isLoading = false;
                        }

                        this.$store.state.appStore.selectedButtonActionId = 0;
                    };

                    this.$store.commit("setAlertData", this.createAlertData());
                    this.$store.commit("showConfirmationAlertWithData", actionToFire);
                }
                else {
                    this.updateSessionData(data);
                }
            },
            updateSessionData(data) {
                this.$store.state.userStore.isLoading = true;
                this.errors = [];
                SessionService.update(this.sessionId, data)
                    .then(async () => {
                        await this.saveRoomMapForSession(this.sessionId);
                        this.getSessionData();
                    })
                    .catch((err) => {
                        this.$store.state.userStore.isLoading = false;
                        this.errors = setErrors(err);
                    });
            },
            updateSessionDataWithVotingsGroups(data) {
                this.$store.state.userStore.isLoading = true;
                this.errors = [];
                SessionService.updateSessionWithAllVotings(this.sessionId, data)
                    .then(async () => {
                        await this.saveRoomMapForSession(this.sessionId);
                        this.getSessionData();
                    })
                    .catch((err) => {
                        this.$store.state.userStore.isLoading = false;
                        this.errors = setErrors(err);
                    });
            },
            getSessionData() {
                SessionService.getSession(this.sessionId).then(
                    (response) => {
                        this.$emit("setSession", response.data);
                        SessionService.getGroups(true).then((response) => {
                            this.$store.commit(
                                "setGroups",
                                response.data
                            );
                            this.$store.state.userStore.isLoading = false;
                            this.$emit('setVisible');
                            this.$store.commit("setEditSessionStatus", true);
                            this.$store.commit('hideEditMeeting');
                        });
                    }
                );
            },
            createInformationToAlert() {
                var info = '';

                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-1') + "</p>";
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-2') + "</p>";
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-3') + "</p>";
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-4') + "</p>";
                info += "<br>" 
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-5') + "</p>";
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-6') + "</p>";
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-7') + "</p>";
                info += "<p>" + this.$t('com.edit-meeting.session-groups-invalid-info-alert-8') + "</p>";

                return info;
            },
            createAlertData() {
                var alertData = {
                    mainText: this.createInformationToAlert(),
                    buttons: [
                        {
                            id: 1,
                            text: this.$t('com.edit-meeting.no-edit-votings'),
                            color: '#d80418'
                        },
                        {
                            id: 2,
                            text: this.$t('com.edit-meeting.assign-groups'),
                            color: '#122fa3'
                        },
                    ]
                };

                return alertData;
            },
            validate(data) {
                var bo = true;
                var err = {};
                //if (data.name.length <= 0) {
                //    err.name = ['Pole wymagane']
                //    bo = false
                //}

                if (this.meeting_date.length <= 0) {
                    err.meeting_date = [this.$t('com.global.required-field')]
                    bo = false
                }

                if (this.meeting_time.length <= 0) {
                    err.meeting_time = [this.$t('com.global.required-field')]
                    bo = false
                }

                if (moment(this.meeting_date, 'yyyy-MM-DD', true).isValid() == false) {
                    err.meeting_date = [this.$t('com.validation-error.invalid-date-format')]
                    bo = false
                }

                if (moment(this.meeting_time, 'LT', true).isValid() == false) {
                    err.meeting_time = [this.$t('com.validation-error.invalid-hour-format')]
                    bo = false
                }

                if (this.end_meeting_date !== null && this.end_meeting_date !== "") {
                    if (moment(this.end_meeting_date, 'yyyy-MM-DD', true).isValid() == false) {
                        err.end_meeting_date = [this.$t('com.validation-error.invalid-date-format')]
                        bo = false
                    }
                    else {
                        let endMeetingDateParse = moment(this.end_meeting_date, 'yyyy-MM-DD');
                        let meetingDateParse = moment(this.meeting_date, 'yyyy-MM-DD')
                        if (meetingDateParse > endMeetingDateParse) {
                            err.end_meeting_date = [this.$t('com.validation-error.session-date-before-after-error')]
                            bo = false
                        }
                    }
                }

                if (this.signature != null && this.signature.length > sessionFormRulesConfig.signature_max_length) {
                    err.signature = [this.$t('com.global.max-length-exception') + ` (${sessionFormRulesConfig.signature_max_length})`]
                    bo = false
                }

                if (this.meeting_place != null && this.meeting_place.length > sessionFormRulesConfig.meeting_place_max_length) {
                    err.meeting_place = [this.$t('com.global.max-length-exception') + ` (${sessionFormRulesConfig.meeting_place_max_length})`]
                    bo = false
                }

                if (Object.keys(data.group_ids).length <= 0) {
                    err.group_ids = [this.$t('com.validation-errors.select-groups')]
                    bo = false
                }

                const additionalTermErrors = validateAdditionalTerms(this.meeting_date, this.meeting_time, this.additional_meeting_dates);

                if (Object.keys(additionalTermErrors).length > 0) {
                    Object.assign(err, additionalTermErrors);
                    bo = false
                }

                if (!bo) {
                    this.$store.state.userStore.isLoading = false;
                    this.errors = setErrors(err)
                }
                return bo
            },
            getDate(date) {
                return date === null ? null : moment(date).format("yyyy-MM-DD");
            },
            getTime(date) {
                return moment(date).format("LT");
            },
            filterGroups() {
                return this.groups
                .filter((group) => group.can_sessions)
                .sort((a,b) => (a?.name ?? '').localeCompare(b?.name ?? '', this.$i18n.locale, { sensitivity: 'base', numeric: true }));
            },
            passErrorMsg,
            isError,
            setErrors,
        },
    };
</script>

<style lang="scss" scoped>
    .edit-meeting {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        background: #00082c75;
        z-index: 11;

        &__form-wrapper {
            max-height: 80vh;
            overflow-y: auto;
            padding-right: 56px;

            &::-webkit-scrollbar {
                width: 12px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #b5b8bd;
                border-radius: 30px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #b5b8bd;
            }

            &::-webkit-scrollbar-track {
                background: #ffffff;
                border: 0.8px solid #dce4ee;
                border-radius: 30px;
                box-shadow: inset 0px 0px 0px 0px #f0f0f0;
            }
        }

        &__form {
            max-height: 90vh;
            padding: 28px 56px;
            background: linear-gradient(146.23deg, #f4f8ff 0%, #ffffff 100%);
            border: 2px solid #ffffff;
            box-sizing: border-box;
            box-shadow: 24px 40px 120px rgba(0, 8, 44, 0.32);
            border-radius: 12px;
            max-width: 760px;
            box-sizing: border-box;
            padding-bottom: 0px;
            padding-right: 0px;
        }

        &__close {
            border: 0px;
            position: relative;
            right: calc(-100% + 48px);
            background-color: transparent;
        }

        &__section-title {
            font-weight: 600;
            font-size: 28px;
            line-height: 128%;
            color: #00082c;
            margin-bottom: 32px;

            &--small {
                font-size: 20px;
                margin-bottom: 24px;
            }
        }

        &__top {
            padding-top: 28px;
            padding-bottom: 28px;
            border-top: 1px solid #dde0e7;
            border-bottom: 1px solid #dde0e7;
        }

        &__row-double {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;
            margin-bottom: 24px;
        }

        &__col-double {
            display: flex;
            flex-direction: column;
            min-width: 0;
        }

        &__label {
            font-weight: 600;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;
            margin-bottom: 8px;

            &--checkbox {
                padding-left: 32px;
                font-weight: normal;
                font-size: 16px;
                line-height: 144%;
                color: #333956;
                margin-bottom: 0px;
                z-index: 8;
                cursor: pointer;
            }
        }

        &__picker {
            padding: 12.5px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            width: 100%;
            min-width: 0;
            height: 56px;
            font-size: 16px;
            line-height: 144%;
            color: #00082c;

            &[type="date"]::-webkit-calendar-picker-indicator {
                color: rgba(0, 0, 0, 0);
                opacity: 1;
                display: block;
                background: url("../../../../../assets/icons/components/callendar.svg") no-repeat;
                background-position-x: 100%;
                width: 22px;
                height: 22px;
                border-width: thin;
            }

            &[type="time"]::-webkit-calendar-picker-indicator {
                color: rgba(0, 0, 0, 0);
                opacity: 1;
                display: block;
                background: url("../../../../../assets/icons/components/clock.svg") no-repeat;
                width: 22px;
                height: 22px;
                border-width: thin;
            }
        }

        &__terms-row {
            display: grid;
            grid-template-columns: 1fr 1fr 56px;
            align-items: start;
            gap: 24px;
            margin-bottom: 16px;
        }

        &__terms-action {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 auto;
            width: 56px;
            height: 56px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            cursor: pointer;
        }

        &__terms-add {
            align-self: flex-start;
            padding: 12px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 600;
            line-height: 145%;
            color: #00082c;
            cursor: pointer;

            &:disabled {
                cursor: not-allowed;
                opacity: 0.5;
            }
        }

        &__picker-wrapper {
            position: relative;
            /*&::after {
            content: "";
            position: absolute;
            top: 8px;
            background: #e2e5eb;
            width: 1px;
            height: 40px;
            right: 56px;
            z-index: 99;
        }*/
        }

        &__select-wrapper {
            position: relative;
        }

        &__select {
            padding: 12.5px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            // TU kluczowe – takie jak input/textarea:
            width: 100%;
            max-width: none;
            min-width: 500px;
            height: 56px;
            font-size: 16px;
            line-height: 144%;
            color: #00082c;
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("@/assets/icons/components/select-arrow.svg");
            background-repeat: no-repeat;
            background-position-x: calc(100% - 20px);
            background-position-y: 50%;

            &:focus {
                border: 1px solid #00082c;
                outline: none;
            }
        }

        &__row {
            margin-bottom: 24px;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
        }

        &__input-text {
            padding: 12.5px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            min-width: 500px;
            width: 100%;
            //height: 56px;
            font-size: 16px;
            color: #00082c;

            &:focus {
                border: 1px solid #00082c;
            }

            &::placeholder {
                font-size: 16px;
                line-height: 144%;
                color: #808396;
            }

            &--small {
                min-width: 0;
                width: 100%;
            }
        }

        &__groups {
            margin-top: 28px;
            padding-bottom: 38px;
            border-bottom: 1px solid #dde0e7;
        }

        &__group {
            margin-top: 28px;
            padding-top: 28px;
            border-top: 1px solid #dde0e7;
        }

        &__checkbox-list {
            display: flex;
            flex-wrap: wrap;
        }

        &__checkbox-section {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            flex: 0 0 50%;
        }

        &__identity {
            margin-top: 28px;
        }

        &__sharing {
            margin-top: 20px;
        }

        &__bottom {
            display: flex;
            justify-content: flex-end;
            gap: 24px;
            padding-bottom: 56px;
            padding-top: 30px;
        }

        &__bottom-btn {
            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
            padding: 18px 40px 17px;
            width: 238px;
            height: 56px;
            border: 1px solid #bbc2ce;
            box-sizing: border-box;
            border-radius: 4px;
            background-color: transparent;
            font-weight: 500;
            font-size: 16px;
            line-height: 132%;
            color: #00082c;
            transition: all 0.2s ease-in-out;

            &:hover {
                background-color: #e8ebef;
            }

            &--red {
                background-color: #d80418;
                border: 0px;
                color: white;
                transition: all 0.2s ease-in-out;

                &:hover {
                    background-color: #ad0313;
                }
            }
        }

        &__switch-section {
            display: flex;
            margin-bottom: 40px;
        }

        &__tooltip {
            position: relative;
            left: 5px;
            top: -3px;
        }

        &__tip-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0px;
            background-color: transparent;
            width: 20px;
            height: 20px;
            position: relative;
            cursor: pointer;

            &:hover .hint {
                opacity: 1;
                display: block;
            }
        }
    }
</style>
